var map = {
	"./bmwicon-动作.svg": "37e0",
	"./bmwicon-回应.svg": "b977",
	"./bmwicon-屏幕分享.svg": "dbd4",
	"./bmwicon-屏幕分享关闭.svg": "f386",
	"./bmwicon-提问.svg": "6519",
	"./bmwicon-摄像头.svg": "71ba",
	"./bmwicon-摄像头关闭.svg": "ff2c",
	"./bmwicon-汽车动画.svg": "9ea9",
	"./bmwicon-电影.svg": "da81",
	"./bmwicon-聊天.svg": "c5df",
	"./bmwicon-视角锁定.svg": "577b",
	"./bmwicon-语音.svg": "afc1",
	"./bmwicon-语音关闭.svg": "9818",
	"./bmwicon-鼓掌.svg": "3358",
	"./bmwicon_back.svg": "ddc7",
	"./bmwicon_personal.svg": "b5a8",
	"./bmwicon_举手.svg": "2fbe",
	"./bmwicon_令牌.svg": "a616",
	"./bmwicon_传送.svg": "8f9f",
	"./bmwicon_净化ui.svg": "aa1b",
	"./bmwicon_列表.svg": "043c",
	"./bmwicon_动作.svg": "8e3b",
	"./bmwicon_双车展示.svg": "82bf",
	"./bmwicon_地图.svg": "1043",
	"./bmwicon_屏幕共享.svg": "90fd",
	"./bmwicon_弹幕.svg": "c879",
	"./bmwicon_拍照.svg": "4754",
	"./bmwicon_提问.svg": "d6cc",
	"./bmwicon_摄像头.svg": "a601",
	"./bmwicon_播放视频.svg": "5f25",
	"./bmwicon_数字人.svg": "9feb",
	"./bmwicon_更换车辆.svg": "ced1",
	"./bmwicon_点点点.svg": "9e51",
	"./bmwicon_点赞.svg": "a21c",
	"./bmwicon_点赞非.svg": "f24f",
	"./bmwicon_禁用屏幕共享.svg": "e1a1",
	"./bmwicon_禁用摄像头.svg": "579e",
	"./bmwicon_禁用语音.svg": "7c5b",
	"./bmwicon_视角.svg": "9b18",
	"./bmwicon_视角锁.svg": "a737",
	"./bmwicon_语音.svg": "6d2c",
	"./bmwicon_贴花.svg": "fe1c",
	"./bmwicon_起立.svg": "a175",
	"./bmwicon_车动画.svg": "2253",
	"./bmwicon_车漆-26.svg": "2a4f",
	"./bmwicon_车漆-27.svg": "a7f3",
	"./bmwicon_退出.svg": "6bba",
	"./bmwicon_邀请-20.svg": "a4f1",
	"./bmwicon_邀请-30.svg": "7c6a",
	"./bmwicon_邀请1.svg": "43ba",
	"./bmwicon_销售带看.svg": "dfcd",
	"./bmwicon_鼓掌.svg": "7730"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8589";